/**
 * Instagram, TikTok and friends open links in an embedded webview, not the
 * system browser. Google refuses its sign-in flows in those webviews
 * (`disallowed_useragent`), so the GIS button either renders and dead-ends or
 * never renders at all — either way the visitor is stuck. Email + OTP is the
 * only path that works there, so Google is hidden entirely.
 *
 * UA matching is the only signal available: webviews expose no capability flag,
 * and the app names are appended to an otherwise ordinary Safari/Chrome UA.
 */
const IN_APP_BROWSER_UA =
  /(Instagram|FBAN|FBAV|FB_IAB|FBIOS|musical_ly|BytedanceWebview|TikTok|Snapchat|Line\/|Twitter|Pinterest|LinkedInApp)/i;

export function isInAppBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  return IN_APP_BROWSER_UA.test(navigator.userAgent);
}
